import { gql } from "@apollo/client";

export const AccountGroupData = gql`
  query SearchAccountGroups($id: ID, $keyword: String) {
    searchAccountGroups(id: $id, keyword: $keyword) {
      _id
      Account_Group
      Unique_Id
      Search_Value
      Report_Side
    }
  }
`;

const AccountGroupConfig = [
  {
    name: "Account_Group_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Account_Group",
        label: "Group Name",
        type: "text",
        min: 2,
        isRequired: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Group_Under",
        label: "Group Under ",
        type: "InputDropForQuery",
        masterName: "Account_Group",
        dropdowncontent: AccountGroupData,
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Order_No",
        label: "Order No",
        type: "text",
        min: 2,
      },
      {
        id: Math.random() * 10,
        name: "Report_Side",
        label: "Report Side ",
        type: "text",
        isRequired: false,
        disabled: true,
      },
    ],
  },
];

const AccountGroupConfigForMerge = [
  {
    id: Math.random() * 10,
    name: "Vehicle_Category_Master",
    fields: [
      {
        id: Math.random() * 10,
        name: "Account_Group",
        label: "Group Name",
        type: "text",
        disabled: true,
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "replace_with",
        label: "Relace With ",
        type: "InputDropForQuery",
        masterName: "Account_Group",
        dropdowndata: AccountGroupData,
      },
    ],
  },
];

export { AccountGroupConfig, AccountGroupConfigForMerge };
